'use client';

import { PressEventsType } from '@osmosis/backend/orm-db';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { H1 } from '@osmosis/tailwind-ui/components/Text';
import { H2 } from '@osmosis/tailwind-ui/components/Text';
import React from 'react';
import EventsPageBanner from './EventsPageBanner';
import CurrentEventsList from './CurrentEventsList';
import PreviousEventsList from './PreviousEventsList';
import { FormattedMessage } from 'react-intl';
import { partitionEvents } from '../../_lib/shared/events';

type Props = {
  events: PressEventsType[];
};

/**
 * Events page.
 */
const EventsPage = (props: Props) => {
  const { events } = props;

  const { upcomingEvents, pastEvents } = partitionEvents(events);

  return (
    <Box>
      <EventsPageBanner />

      <Box cn="max-w-[1000px] m-auto sm:p-5 p-8 gap-8 flex flex-col">
        <Box cn="flex flex-col gap-8">
          <H1>
            <FormattedMessage
              id="events-page.upcoming_events"
              defaultMessage="Upcoming Events"
            />
          </H1>
          <CurrentEventsList events={upcomingEvents} />
        </Box>

        <Box cn="flex flex-col gap-8">
          <H2>
            <FormattedMessage
              id="events-page.watch_past_events"
              defaultMessage="Watch Past Events On-Demand"
            />
          </H2>
          <PreviousEventsList events={pastEvents} />
        </Box>
      </Box>
    </Box>
  );
};

export default EventsPage;
